import * as React from 'react';
import { FlowType } from '../../../../services/userflow/UserFlowService';
import { BootstrapPage } from './BootstrapPage';

interface BootstrapLoginPageProps {
  location: Location;
}

const BootstrapLoginPage: React.FC<BootstrapLoginPageProps> = ({ location }) => {
  return <BootstrapPage flow={FlowType.login} location={location} />;
};

export { BootstrapLoginPage };
